<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div style="margin-bottom: 10px">
        <el-radio-group v-model="table.params.type" @change="handleTabs">
          <el-radio-button :label="1">人才币发票</el-radio-button>
          <el-radio-button :label="2">服务费发票</el-radio-button>
        </el-radio-group>
      </div>
      <div style="margin-bottom: 10px">
        <el-radio-group
          size="medium"
          v-model="table.params.status"
          @change="handleTabs2"
        >
          <el-radio-button :label="1">待开票</el-radio-button>
          <el-radio-button :label="2">已开票</el-radio-button>
        </el-radio-group>
      </div>
      <div>
        <el-form
          ref="elFormDom"
          inline
          :model="table.params"
          size="small"
          class="flex"
        >
          <el-form-item label="企业名称" prop="company_id">
            <el-select
              v-model="table.params.company_id"
              filterable
              clearable
              placeholder="请选择"
              @change="handleSearch"
            >
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table__wrap">
      <template v-if="table.params.type == 1">
        <VTable
          v-if="table.params.status == 1"
          has-pagionation
          indexLabel="序号"
          title=""
          :field="field1"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:pay_type="{ row }">
            {{ row.pay_type == 1 ? "微信" : "支付宝" }}
          </template>
          <template v-slot:action="{ row }">
            <el-button type="text" @click="uploadInvoice(row)"
              >上传发票</el-button
            >
          </template>
        </VTable>
        <VTable
          v-if="table.params.status == 2"
          has-pagionation
          indexLabel="序号"
          title=""
          :field="field2"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:pay_type="{ row }">
            {{ row.pay_type == 1 ? "微信" : "支付宝" }}
          </template>
          <template v-slot:action="{ row }">
            <!-- <el-dropdown
              trigger="click"
              placement="bottom"
              @command="handleCommand($event, row)"
            > -->
            <el-button type="text" @click="viewIncoice(row)"
              >查看发票</el-button
            >
            <!-- <el-dropdown-menu
                slot="dropdown"
                v-if="row.refund_img && row.refund_img.length"
              >
                <el-dropdown-item
                  v-for="(item, index) in row.refund_img"
                  :command="index"
                  :key="index"
                  >凭证{{ index + 1 }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown> -->
            <el-button
              style="margin-left: 10px"
              type="text"
              @click="cancelInvoice(row)"
              >作废发票</el-button
            >
          </template>
        </VTable>
      </template>
      <template v-if="table.params.type == 2">
        <VTable
          v-if="table.params.status == 1"
          has-pagionation
          indexLabel="序号"
          title=""
          :field="field3"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:pay_type="{ row }">
            {{ row.pay_type == 1 ? "微信" : "支付宝" }}
          </template>
          <template v-slot:num="{ row }">
            <el-button type="text" @click="viewResource(row)"
              >{{ row.num }}人</el-button
            >
          </template>
          <template v-slot:action="{ row }">
            <el-button type="text" @click="uploadInvoice(row)"
              >上传发票</el-button
            >
          </template>
        </VTable>
        <VTable
          v-if="table.params.status == 2"
          has-pagionation
          indexLabel="序号"
          title=""
          :field="field4"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:pay_type="{ row }">
            {{ row.pay_type == 1 ? "微信" : "支付宝" }}
          </template>
          <template v-slot:num="{ row }">
            <el-button type="text" @click="viewResource(row)"
              >{{ row.num }}人</el-button
            >
          </template>
          <template v-slot:action="{ row }">
            <!-- <el-dropdown
              trigger="click"
              placement="bottom"
              @command="handleCommand($event, row)"
            > -->
            <el-button type="text" @click="viewIncoice(row)"
              >查看发票</el-button
            >
            <!-- <el-dropdown-menu
                slot="dropdown"
                v-if="row.refund_img && row.refund_img.length"
              >
                <el-dropdown-item
                  v-for="(item, index) in row.refund_img"
                  :command="index"
                  :key="index"
                  >凭证{{ index + 1 }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown> -->
            <el-button
              style="margin-left: 10px"
              type="text"
              @click="cancelInvoice(row)"
              >作废发票</el-button
            >
          </template>
        </VTable>
      </template>
    </div>
    <!-- 表格 -->
    <uploadInvoice @update="getTable" ref="uploadInvoiceRef"></uploadInvoice>
    <deductionSource ref="deductionSourceRef"></deductionSource>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import uploadInvoice from "./components/uploadInvoice.vue";
import deductionSource from "./components/deductionSource.vue";
export default {
  name: "CompanyList",
  mixins: [mixinTable],
  components: {
    VTable,
    uploadInvoice,
    deductionSource,
  },
  data() {
    return {
      companyList: [],
      field1: [
        { name: "company_name", label: "企业名称", hidden: false },
        { name: "xy_code", label: "税号", hidden: false },
        { name: "amount", label: "开票金额", hidden: false },
        { name: "pay_type", label: "支付渠道", hidden: false },
        { name: "order_no", label: "交易流水号", hidden: false },
        { name: "invoice_time", label: "申请开票时间", hidden: false },
        { name: "action", label: "操作", hidden: false },
      ],
      field2: [
        { name: "company_name", label: "企业名称", hidden: false },
        { name: "xy_code", label: "税号", hidden: false },
        { name: "amount", label: "开票金额", hidden: false },
        { name: "pay_type", label: "支付渠道", hidden: false },
        { name: "order_no", label: "交易流水号", hidden: false },
        { name: "invoice_time", label: "申请开票时间", hidden: false },
        { name: "upload_time", label: "上传开票时间", hidden: false },
        { name: "action", label: "操作", hidden: false },
      ],
      field3: [
        { name: "company_name", label: "企业名称", hidden: false },
        { name: "xy_code", label: "税号", hidden: false },
        { name: "amount", label: "开票金额", hidden: false },
        { name: "num", label: "扣款来源", hidden: false },
        { name: "create_time", label: "申请开票时间", hidden: false },
        { name: "action", label: "操作", hidden: false },
      ],
      field4: [
        { name: "company_name", label: "企业名称", hidden: false },
        { name: "xy_code", label: "税号", hidden: false },
        { name: "amount", label: "开票金额", hidden: false },
        { name: "num", label: "扣款来源", hidden: false },
        { name: "create_time", label: "申请开票时间", hidden: false },
        { name: "upload_time", label: "上传开票时间", hidden: false },
        { name: "action", label: "操作", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          type: 1,
          status: 1,
          company_id: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
    };
  },
  created() {
    this.getTable();
    this.getCompanyList();
  },
  methods: {
    getCompanyList() {
      this.$http
        .get("admin/company/list", {
          params: { page: 1, count: 10000, type: 2 },
        })
        .then((res) => {
          if (res.code === 1) {
            this.companyList = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getTable() {
      this.table.data = [];
      let params_ = {
        ...this.table.params,
      };
      this.$http.get("/admin/invoice/list", { params: params_ }).then((res) => {
        if (res.code === 1) {
          this.table.data = res.data.list.map((item) => {
            return {
              ...item,
              refund_img: item.invoice_file,
            };
          });
          console.log(this.table.data);
          this.table.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    reset() {
      this.$refs.elFormDom.resetFields();
      this.getTable();
    },
    // 切换状态
    handleTabs(value) {
      this.table.params.page = 1;
      this.$refs.elFormDom.resetFields();
      this.table.data = [];
      this.getTable();
    },
    handleTabs2() {
      this.table.data = [];
      this.getTable();
    },
    refresh(status) {
      this.table.params.status === status;
      this.getTable();
    },
    uploadInvoice(row) {
      let dom = this.$refs.uploadInvoiceRef;
      dom.toggle(true);
      dom.getDetail({
        ...row,
        type: this.table.params.type,
      });
      dom = null;
    },
    viewResource(row) {
      let dom = this.$refs.deductionSourceRef;
      dom.toggle(true);
      dom.getDetail({
        ...row,
        type: this.table.params.type,
      });
      dom = null;
    },
    handleCommand(e, row) {
      console.log(e, row);
      window.open(row.refund_img[e]);
    },
    viewIncoice(row) {
      window.open(row.refund_img[0]);
    },
    cancelInvoice(row) {
      this.$confirm(`确认作废发票吗？`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        let params = {
          id: row.id,
          type: this.table.params.type,
        };
        this.$http.post("/admin/invoice/cancel", params).then((res) => {
          if (res.code === 1) {
            this.$message.success("作废成功！");
            this.getTable();
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
</style>